import { useEffect } from "react";

import {
  extendedApiSlice,
  useAppDispatch,
  useAppSelector,
  selectVerificationState,
  setIsVerificationStatusLoading,
  useCreateGenerationSessionMutation,
  useGenerateGenerationJWTMutation,
  useGetSessionQuery,
} from "../../store";
import { userAccounts } from "../constants";

export const useGenerationSessionInitialization = () => {
  const dispatch = useAppDispatch();

  const { data: sessionData, refetch: refetchSession } = useGetSessionQuery();
  const verificationState = useAppSelector(selectVerificationState);

  const generationDetails = userAccounts[verificationState.verificationStatus];

  const [generateGenerationJWT] = useGenerateGenerationJWTMutation();
  const [createGenerationSession] = useCreateGenerationSessionMutation();

  // Original session initialization logic
  useEffect(() => {
    async function initializeSession() {
      try {
        const jwtResult = await generateGenerationJWT(
          generationDetails
        ).unwrap();
        await createGenerationSession(jwtResult).unwrap();
        dispatch(setIsVerificationStatusLoading(false));
      } catch (error) {
        console.log("Exception during initialization: ", error);
        dispatch(setIsVerificationStatusLoading(false));
      }
    }

    if (generationDetails) {
      initializeSession();
    }
  }, [
    generationDetails,
    createGenerationSession,
    dispatch,
    generateGenerationJWT,
  ]);

  // Separate effect to handle verification status changes
  useEffect(() => {
    if (
      (sessionData?.user.verificationStatus !==
        verificationState.verificationStatus &&
        sessionData?.isLoggedIn) ||
      !sessionData?.isLoggedIn
    ) {
      // Clear the session cache before refetching
      dispatch(extendedApiSlice.util.invalidateTags(["Auth"]));

      refetchSession()
        .catch((error) => console.log("Session refetch failed:", error))
        .finally(() => {
          dispatch(setIsVerificationStatusLoading(false));
        });
    }
  }, [
    verificationState.verificationStatus,
    sessionData?.user.verificationStatus,
    sessionData?.isLoggedIn,
    refetchSession,
    dispatch,
  ]);

  return {
    sessionData,
    verificationState,
    generationDetails,
  };
};
